/* Scara de straturi — regula R1 (vezi assets/z-layers.css).
   Cand un flotant (chat, back-to-top, teaser Klaviyo) se suprapune peste
   un control de cumparare vizibil, flotantul primeste data-z-yield si se
   retrage pana cand controlul iese de sub el. */
(function () {
  var CONTROLS = [
    '.product-form__submit',
    '.shopify-payment-button__button',
    '.product-form__quantity',
    '.product-sticky-cart button[name="add"]',
    '[name="checkout"]',
    '#mini-cart a[href="/cart"]',
    '.mobile-facets__footer .button'
  ].join(',');
  var PAD = 8;

  function floats() {
    var list = [];
    var chat = document.querySelector('shopify-chat');
    if (chat && !chat.hasAttribute('open') && chat.shadowRoot) {
      var act = chat.shadowRoot.querySelector('[part~="activator"], .activator');
      if (act) list.push([chat, act.getBoundingClientRect()]);
    }
    var btt = document.getElementById('BackToTop');
    if (btt) list.push([btt, btt.getBoundingClientRect()]);
    document.querySelectorAll('[class*="kl-teaser-"]').forEach(function (t) {
      list.push([t, t.getBoundingClientRect()]);
    });
    return list;
  }

  function visibleRects() {
    var out = [], vw = innerWidth, vh = innerHeight;
    document.querySelectorAll(CONTROLS).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width < 2 || r.height < 2 || r.bottom <= 0 || r.top >= vh || r.right <= 0 || r.left >= vw) return;
      if (getComputedStyle(el).visibility === 'hidden') return;
      out.push(r);
    });
    return out;
  }

  function hit(a, b) {
    return a.width > 0 && a.height > 0 &&
      a.left < b.right + PAD && a.right > b.left - PAD &&
      a.top < b.bottom + PAD && a.bottom > b.top - PAD;
  }

  /* fereastra de chat in modul extins (Shopify Inbox nu expune starea pe host) */
  function chatExpanded(chat) {
    var stack = [chat.shadowRoot];
    while (stack.length) {
      var root = stack.pop();
      if (!root) continue;
      if (root.querySelector('.panel--size-expanded')) return true;
      root.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) stack.push(e.shadowRoot); });
    }
    return false;
  }

  var queued = false;
  function update() {
    queued = false;
    var chat = document.querySelector('shopify-chat');
    if (chat) {
      if (chat.hasAttribute('open') && chatExpanded(chat)) chat.setAttribute('data-z-expanded', '');
      else chat.removeAttribute('data-z-expanded');
    }
    var ctrls = visibleRects();
    floats().forEach(function (f) {
      var over = ctrls.some(function (c) { return hit(f[1], c); });
      if (over) f[0].setAttribute('data-z-yield', '');
      else f[0].removeAttribute('data-z-yield');
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }

  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule);
  document.addEventListener('transitionend', schedule, true);
  document.addEventListener('click', function () { setTimeout(schedule, 60); }, true);
  setInterval(schedule, 600); /* prinde flotantele injectate tarziu si bara sticky animata */
  schedule();
})();
